import React from 'react'
import Title from '../../../components/Title/Title'
import OCTable from './components/OCTable/OCTable'
import { array2022 } from '../../../common/constants/organizingCommittee'


const OrganizingCommittee2022page = () => {
  return (
    <div>
      <Title>Organizing Committee</Title>
      <OCTable array={array2022} />
    </div>
  )
}

export default OrganizingCommittee2022page
